import loginStyle from "../../../../../../assets/scss/common/modal/loginModal.module.scss";
import memberStyle from "../../../../../../assets/scss/sub/editMember.module.scss";
import React, {RefObject} from "react";
import {Option} from "../../../../../../types/signup";
import {ValidateStatus} from "../hooks/useSignupValidator";
import {StyleRequestType} from "../../../../../../types/common";
import {useTranslation} from "react-i18next";

interface Props {
    nationality: string;
    setNationality: (_: string) => void;
    showNation: boolean;
    setShowNation: (_: boolean) => void;
    nationValidate: ValidateStatus;
    setNationValidate: (_: ValidateStatus) => void;
    styleRequestType: StyleRequestType;
    nationalityRef?: RefObject<HTMLDivElement>;
}

export function SignupNationField({nationality, setNationality, showNation, setShowNation, nationValidate, setNationValidate, styleRequestType, nationalityRef}: Props){
    const { t } = useTranslation("userInfo");

    const nationOptions: Option[] = [
        { key: '', value: t('form.nation.none')},
        { key: 'KR', value: t('form.nation.kr')},
        { key: 'US', value: t('form.nation.us')},
        { key: 'MN', value: t('form.nation.mn')},
        { key: 'TW', value: t('form.nation.tw')},
        { key: 'VN', value: t('form.nation.vn')},
    ];

    const selectedOption = nationOptions.find(option => option.key === nationality);
    const isDefaultOption = !selectedOption || selectedOption.key === '';
    const styles = styleRequestType === StyleRequestType.SIGN_UP ? loginStyle :  memberStyle;

    const handleOptionClick = (option: Option) => {
        setNationality(option.key);
        setShowNation(false);
        setNationValidate(ValidateStatus.NONE)
    };

    return (
        <div className={styles.selectWrapper}>
            <div className={styles.selectTitleWrapper}>
                <span className={styles.highLight}>{t('form.required')}</span>
                <span className={styles.titleText}>{t('form.nation.label')}</span>
            </div>

            <div className={styles.selectTextFieldWrapper} onClick={() => setShowNation(!showNation)}>
                <span className={`${styles.selectText} ${isDefaultOption ? styles.defaultText : ''}`}>
                  {selectedOption?.value}
                </span>
                <div className={styles.arrowImg}></div>
                {showNation && (
                    <div className={styles.optionStyle}>
                        {nationOptions.filter(option => option.key !== '').map((option) => (
                            <button
                                key={option.key}
                                className={`${styles.optionTextWrapper} ${option.key === nationality ? styles.selectedOption : ''}`}
                                onClick={() => handleOptionClick(option)}
                            >
                                <span ref={nationalityRef}
                                      className={`${styles.optionText} ${option.key === nationality ? styles.selectedOption : ''}`}>{option.value}</span>
                            </button>
                        ))}
                    </div>
                )}
            </div>
            {nationValidate === ValidateStatus.UNFILLED &&
                (<span className={styles.validateText}>{t('edit.warning.nation')}</span>)
            }
        </div>
    )
}